document.addEventListener('DOMContentLoaded', () => {
    const swiperInitStructure = document.querySelectorAll('.swiper-init-structure');
    if (swiperInitStructure.length > 0) {
        swiperInitStructure.forEach(item => {
            item.querySelector('.woocommerce').classList.add('swiper');
            item.querySelector('ul.products').classList.add('swiper-wrapper')
            item.querySelectorAll('li.product').forEach(product => {
                product.classList.add('swiper-slide');
            });

            const swiperNavPrev = document.createElement('div');
            swiperNavPrev.classList.add('swiper-button-prev');
            item.appendChild(swiperNavPrev);

            const swiperNavNext = document.createElement('div');
            swiperNavNext.classList.add('swiper-button-next');
            item.appendChild(swiperNavNext);
        });
    }

    new Swiper('.swiper', {
        loop: true,
        slidesPerView: 4,
        spaceBetween: 16,
        autoHeight: false,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            1024: {
                slidesPerView: 4
            },
            768: {
                slidesPerView: 3,
            },
            424: {
                slidesPerView: 2,
            },
            0: {
                slidesPerView: 2,
            }
        },
    });
});